export default __webpack_public_path__ + "static/media/chat_bot_image11.b0ff66cb.jpg";